<template>
    <main class="research-home">
        <section class="research-hero">
            <div class="hero-copy">
                <div class="eyebrow"><i></i> YAXUN SPORTS INTELLIGENCE</div>
                <h1>专业研判，<em>建立在可核验的数据之上</em></h1>
                <p>平台认证分析团队 <b>·</b> 多维赛事模型 <b>·</b> 赛前信息核验</p>
                <div class="hero-trust"><span><i>✓</i><b>独立研究</b><small>不受商业干扰</small></span><span><i>▥</i><b>数据校验</b><small>多维度模型验证</small></span><span><i>★</i><b>持续更新</b><small>专注足球深度研究</small></span></div>
                <div class="hero-actions"><router-link class="primary" to="/recommend">查看专家贴士 <b>→</b></router-link><router-link class="secondary" to="/news">浏览体育资讯 <b>→</b></router-link></div>
                <div class="hero-guarantee"><i>✓</i><span><b>诚信保证</b><em>·</em> 不中退还全部球币</span></div>
                <div class="hero-note"><span>YAXUN SPORTS</span><span>DECISIONS BACKED BY DATA</span></div>
            </div>
        </section>

        <section class="home-priority-fixtures" v-if="priorityFixtures.length">
            <header class="priority-fixtures-head">
                <div><b class="home-section-index">01</b><small>YAXUN MATCH RADAR · BEIJING TIME</small><h2>亚讯赛事雷达</h2><p>专家当日发布 · 重大联赛优先 · 无当日则回溯历史</p></div>
                <router-link to="/bifen">全部赛程 →</router-link>
            </header>
            <div class="priority-fixtures-grid">
                <router-link v-for="item in priorityFixtures.slice(0,8)" :key="'priority-'+item.id" :to="item.recommend_id?('/recommend/'+item.recommend_id):('/match/'+item.id)" class="priority-fixture-card" :class="{'is-today':isBeijingToday(item),'is-major':majorMatchScore(item)>=70}">
                    <div class="priority-fixture-meta">
                        <time><small>{{fixtureDate(item)}}</small><strong>{{fixtureClock(item)}}</strong></time>
                        <span>{{item.match_type}}</span>
                    </div>
                    <div class="priority-fixture-teams">
                        <span><team-badge :name="item.shangpan" :size="32"/><b>{{item.shangpan}}</b></span>
                        <em>{{item.bifen || 'VS'}}</em>
                        <span><team-badge :name="item.xiapan" :size="32"/><b>{{item.xiapan}}</b></span>
                    </div>
                    <footer><b>{{isBeijingToday(item)?'今日焦点':'赛程回顾'}}</b><span>{{item.recommend_num || 0}} 位专家关注</span></footer>
                </router-link>
            </div>
        </section>

        <div class="home-dashboard">
            <section class="home-section recommendation-section" ref="recommendationSection">
                <div class="section-heading"><b class="home-section-index">02</b><div><small>YAXUN RESEARCH DESK</small><h2>亚讯精选研判</h2><p>数据模型与专家判断交叉验证</p></div><router-link to="/recommend">更多研判 →</router-link></div>
                <div class="category-tabs"><button :class="balltab===1?'active':''" @click="balltab=1">足球推荐</button><button :class="balltab===2?'active':''" @click="balltab=2">篮球推荐</button></div>
                <div class="home-recommend-sync recommend-page">
                    <div class="home-loading" v-if="!football_list.length && !basketball_list.length"><van-skeleton row="6" title/></div>
                    <recommend-mini v-else-if="balltab===1" :list="football_list" :type="0"/>
                    <recommend-mini v-else :list="basketball_list" :type="0"/>
                </div>
            </section>

            <section class="home-section expert-section" ref="expertSection">
                <div class="section-heading"><b class="home-section-index">03</b><div><small>YAXUN EXPERT MATRIX</small><h2>亚讯专家智库</h2><p>默认显示近7天统计</p></div><router-link to="/rank">进入专家智库 →</router-link></div>
                <ul class="expert-grid" v-if="rankedHomeExperts.length" ref="expertGrid">
                    <li v-for="(c,i) in rankedHomeExperts.slice(0,6)" :key="c.id"><router-link :to="'/member/'+c.id">
                        <em class="expert-number">{{String(i+1).padStart(2,'0')}}</em><img :src="c.portrait || defimg" @error="$event.target.src=defimg"><div class="expert-copy"><b>{{c.name}} <i>认证专家</i></b><span>{{c.intro || '专注足球赛事数据、阵容与战术研究'}}</span></div><strong>{{c.winrate || c.seven_day_fb || 0}}%<small>7天命中率</small></strong>
                        <div class="expert-stats"><span><b>{{c.recommend_count || 0}}</b><small>历史分析</small></span><span><b>{{c.hot_sales || 0}}</b><small>热销场次</small></span><span><b>{{c.fans_count || 0}}</b><small>关注人数</small></span><span><b>{{c.roi || 0}}%</b><small>回报率</small></span><span><b>{{c.stability || 0}}%</b><small>稳定性</small></span></div>
                    </router-link></li>
                </ul>
                <div class="empty-state" v-else><b>暂无专家数据</b></div>
            </section>
        </div>

        <!-- 暂时隐藏研究数据看板；专家数据充足后将 showResearchDashboard 改为 true 即可恢复。 -->
        <section v-if="showResearchDashboard" class="home-section research-metrics">
            <div class="section-heading"><div><small>RESEARCH DATA CENTER</small><h2>研究数据看板</h2><p>用数据洞察足球，用研究创造价值</p></div><router-link to="/rank">查看专家数据 →</router-link></div>
            <div class="metric-dashboard">
                <div class="metric-summary"><i>▤</i><span>今日研究<b>{{football_list.length + basketball_list.length}}</b><small>后台实时发布</small></span></div>
                <div class="metric-summary verified"><i>✓</i><span>已验证观点<b>{{verifiedCount}}</b><small>赛果持续校验</small></span></div>
                <div class="metric-summary experts"><i>●</i><span>活跃专家<b>{{userlist.length}}</b><small>研究团队在线</small></span></div>
                <div class="metric-summary updated"><i>◎</i><span>数据更新<b>实时</b><small>{{today}} 同步</small></span></div>
                <div class="metric-trend"><div><b>近7日研究趋势</b><small>持续追踪 · 公开验证</small></div><span class="trend-bars"><i v-for="n in 12" :key="n" :style="{height:(28 + ((n*13)%52))+'%'}"></i></span></div>
            </div>
        </section>

        <section class="home-section report-section expert-preview-section" v-if="expertPreview.length">
            <div class="section-heading"><div><small>EXPERT MATCH ANALYSIS</small><h2>专家分析预览</h2><p>认证专家每日原创足球赛事预测</p></div><router-link to="/news">查看全部专家分析 →</router-link></div>
            <div class="research-preview-grid"><router-link v-for="c in expertPreview" :key="'expert-'+c.id" :to="'/news/'+c.id" class="research-preview-card"><img :src="articleAvatar(c,false)" @error="$event.target.src=defimg" :alt="(c.author||'认证专家')+'头像'"><div><h3>{{c.title}}</h3><p>{{c.summary || '结合球队近况、阵容变化与赛事数据，提供清晰审慎的赛前分析。'}}</p><small>{{c.time}} · {{c.author || '认证专家'}}</small></div></router-link></div>
        </section>

        <section class="home-section report-section depth-preview-section" v-if="reportPreview.length">
            <div class="section-heading"><div><small>IN-DEPTH REPORTS</small><h2>深度赛前报告</h2><p>阵容、战术、交锋与数据趋势</p></div><router-link to="/news">更多报告 →</router-link></div>
            <div class="research-preview-grid"><router-link v-for="c in reportPreview" :key="'report-'+c.id" :to="'/news/'+c.id" class="research-preview-card report-preview-card"><img :src="articleAvatar(c,true)" @error="$event.target.src=siteLogo" alt="亚讯体育研究报告"><div><h3>{{c.title}}</h3><p>{{c.summary || '从阵容、战术与数据趋势出发，拆解比赛的关键影响因素。'}}</p><small>{{c.time}} · {{c.author || '亚讯体育研究中心'}}</small></div></router-link></div>
        </section>
        <section class="research-bulletin"><b>{{today}}</b><span>赛事资料持续更新 · 专家观点独立发布 · 多维数据交叉验证</span><i>亚讯体育 · 独立观点，仅供参考</i></section>
    </main>
</template>

<script>
import defPortrait from '../assets/images/default-analyst-v3.jpg'
import siteLogo from '../assets/images/yaxun-sports-logo.svg'
import RecommendMini from './public/recommend_mini'
import TeamBadge from './public/team_badge'
export default {
    name:'index',components:{RecommendMini,TeamBadge},
    data(){return{today:new Date().toISOString().slice(0,10),showResearchDashboard:false,football_list:[],basketball_list:[],userlist:[],rank_user_list:[],score_list:[],balltab:1,expertDisplayCount:0,balanceTimer:null,defimg:defPortrait,siteLogo,dan_list:[],expert_news:[],report_news:[]}},
    computed:{
        verifiedCount(){return this.football_list.concat(this.basketball_list).filter(item=>Number(item.result_id)>0).length},
        expertPreview(){return (this.expert_news.length?this.expert_news:this.dan_list.filter(item=>item.is_expert)).slice(0,3)},
        reportPreview(){const rows=this.report_news.length?this.report_news:this.dan_list.filter(item=>!item.is_expert);return (rows.length?rows:this.dan_list).slice(0,3)},
        rankedHomeExperts(){
            const rows=(this.rank_user_list.length?this.rank_user_list:this.userlist).slice().sort((a,b)=>{
                const rateDiff=Number(b.winrate||b.seven_day_fb||0)-Number(a.winrate||a.seven_day_fb||0)
                if(rateDiff)return rateDiff
                const roiDiff=Number(b.roi||0)-Number(a.roi||0)
                if(roiDiff)return roiDiff
                return Number(b.recommend_count||0)-Number(a.recommend_count||0)
            })
            return rows
        },
        beijingMonthDay(){
            const parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Shanghai',month:'2-digit',day:'2-digit'}).formatToParts(new Date())
            const month=parts.find(p=>p.type==='month'),day=parts.find(p=>p.type==='day')
            return month&&day?month.value+'-'+day.value:''
        },
        priorityFixtures(){
            return this.score_list.slice().sort((a,b)=>{
                const majorDiff=this.majorMatchScore(b)-this.majorMatchScore(a)
                if(majorDiff)return majorDiff
                const todayDiff=Number(this.isBeijingToday(b))-Number(this.isBeijingToday(a))
                if(todayDiff)return todayDiff
                const recommendDiff=Number(b.recommend_num||0)-Number(a.recommend_num||0)
                if(recommendDiff)return recommendDiff
                return String(a.time||'').localeCompare(String(b.time||''))
            })
        }
    },
    watch:{
        balltab(){this.scheduleExpertBalance(true)},
        football_list(){this.scheduleExpertBalance(true)},
        basketball_list(){this.scheduleExpertBalance(true)},
        rank_user_list(){this.scheduleExpertBalance(true)}
    },
    created(){this.getList();this.getNewsPreviews()},
    mounted(){window.addEventListener('resize',this.scheduleExpertBalance)},
    activated(){this.scheduleExpertBalance()},
    updated(){this.scheduleExpertBalance()},
    beforeDestroy(){window.removeEventListener('resize',this.scheduleExpertBalance);clearTimeout(this.balanceTimer)},
    methods:{
        scheduleExpertBalance(reset){
            if(reset===true)this._expertRowHeights=null
            clearTimeout(this.balanceTimer)
            this.balanceTimer=setTimeout(()=>this.$nextTick(this.balanceExpertCards),80)
        },
        balanceExpertCards(){
            const left=this.$refs.recommendationSection
            const right=this.$refs.expertSection
            const grid=this.$refs.expertGrid
            if(!left||!right||!grid)return
            const rows=Array.from(grid.children)
            if(!rows.length)return
            const list=left.querySelector('.home-synced-picks')
            const loading=left.querySelector('.home-loading')
            const last=list||loading||left.lastElementChild
            if(!last)return
            const leftRect=left.getBoundingClientRect()
            const lastRect=last.getBoundingClientRect()
            const leftStyle=window.getComputedStyle(left)
            const bottomPadding=parseFloat(leftStyle.paddingBottom)||0
            const targetHeight=lastRect.bottom-leftRect.top+bottomPadding
            const measured=rows.map(row=>row.offsetHeight)
            if(!this._expertRowHeights||measured.some(height=>height>0)){
                const previous=this._expertRowHeights||[]
                this._expertRowHeights=measured.map((height,index)=>height||previous[index]||0)
            }
            const visibleHeights=this._expertRowHeights.filter(Boolean)
            const fallback=visibleHeights.length?visibleHeights.reduce((sum,height)=>sum+height,0)/visibleHeights.length:150
            const rightStyle=window.getComputedStyle(right)
            const rightRect=right.getBoundingClientRect()
            const gridRect=grid.getBoundingClientRect()
            const gridTop=Math.max(0,gridRect.top-rightRect.top)
            const available=Math.max(0,targetHeight-gridTop-(parseFloat(rightStyle.paddingBottom)||0))
            let used=0,count=0
            for(const height of this._expertRowHeights){
                const rowHeight=height||fallback
                if(count>0&&used+rowHeight>available+6)break
                used+=rowHeight;count++
            }
            count=Math.min(Math.max(1,count),this.rankedHomeExperts.length)
            if(count!==this.expertDisplayCount)this.expertDisplayCount=count
        },
        matchMonthDay(item){
            const matched=String(item&&item.time||'').match(/(?:\d{4}-)?(\d{2}-\d{2})/)
            return matched?matched[1]:''
        },
        isBeijingToday(item){return this.matchMonthDay(item)===this.beijingMonthDay},
        fixtureDate(item){return this.matchMonthDay(item)||'--'},
        fixtureClock(item){const matched=String(item&&item.time||'').match(/(\d{1,2}:\d{2})/);return matched?matched[1]:'--:--'},
        majorMatchScore(item){
            if(Number(item&&item.priority_score||0)>0)return Number(item.priority_score)
            const text=[item.match_type,item.shangpan,item.xiapan].join(' ')
            const levels=[
                {score:100,keys:['世界杯','世俱杯','世界俱乐部杯','欧冠','欧洲冠军联赛','欧洲杯','美洲杯']},
                {score:90,keys:['欧罗巴杯','欧罗巴联赛','欧联杯','欧联','欧洲联赛']},
                {score:85,keys:['英超','西甲','德甲','意甲','法甲']},
                {score:80,keys:['英联杯','足总杯','国王杯','德国杯','意大利杯','法国杯']},
                {score:75,keys:['亚冠','亚洲冠军','解放者杯','南美解放者杯']},
                {score:65,keys:['世界杯预选','欧洲杯预选','欧国联','亚洲杯','国家队']},
                {score:45,keys:['英冠','西乙','德乙','意乙','法乙','荷甲','葡超','苏超','巴甲','阿甲','美职']},
                {score:20,keys:['西丙','意丙','德丙','英甲','英乙']}
            ]
            const level=levels.find(group=>group.keys.some(key=>text.indexOf(key)>-1))
            return level?level.score:0
        },
        articleAvatar(item,siteOnly){
            if(siteOnly)return this.siteLogo
            if(item.portrait)return item.portrait.indexOf('http')===0?item.portrait:this.$api.imgBaseUrl+item.portrait
            const expert=this.userlist.concat(this.rank_user_list).find(user=>user.name===item.author)
            return expert&&expert.portrait?expert.portrait:this.defimg
        },
        getNewsPreviews(){
            this.$post(this.$api.news_list,{page:1,pageSize:3,channel:'expert'}).then(res=>{if(res&&res.code===1)this.expert_news=res.data.news_list||[]}).catch(()=>false)
            this.$post(this.$api.news_list,{page:1,pageSize:3,channel:'event'}).then(res=>{if(res&&res.code===1)this.report_news=res.data.news_list||[]}).catch(()=>false)
        },
        getList(){
            this.$post(this.$api.home,{page:1}).then(res=>{
                if(!res||res.code!==1)return
                this.$store.commit('SET_NOTICE',res.data.notice_count||0)
                const users=res.data.user_list||[];users.forEach(i=>{if(i.portrait)i.portrait=this.$api.imgBaseUrl+i.portrait});this.userlist=users
                const rankUsers=res.data.rank_user_list||[];rankUsers.forEach(i=>{if(i.portrait)i.portrait=this.$api.imgBaseUrl+i.portrait});this.rank_user_list=rankUsers
                const football=res.data.football_list||[];football.forEach(i=>{if(i.user.portrait)i.user.portrait=this.$api.imgBaseUrl+i.user.portrait});this.football_list=football
                const basketball=res.data.basketball_list||[];basketball.forEach(i=>{if(i.user.portrait)i.user.portrait=this.$api.imgBaseUrl+i.user.portrait});this.basketball_list=basketball
                this.score_list=res.data.score_list||[];this.dan_list=res.data.dan_list||[]
            }).catch(()=>this.$toast.fail('首页数据读取失败'))
        }
    }
}
</script>

<style scoped></style>
